module.exports = __webpack_public_path__ + "media/category_icons/EmergencyMedicine-b1e0fa4a.svg";